// extracted by mini-css-extract-plugin
module.exports = {"feature":"_02712f2b3b--feature--yjnlu","hoverBackground":"_02712f2b3b--hoverBackground--VHudv","link":"_02712f2b3b--link--u8TK7"};